import type { NavItems } from '@unifyapps/carbon/components/NavigationContainer/types';
import {
  getActivePathnames,
  getIsNavGroupActive,
} from '@unifyapps/carbon/components/NavigationContainer/utils';
import {
  getActiveNavItem,
  getIsPathActive,
} from '@unifyapps/carbon/components/NavigationContainer/variants/SideNavigation/helpers';
import type { NavItem } from '@unifyapps/defs/types/interface';
import type { ActiveNavItems } from './navigationForContextTypes';

export function computeActiveNavItems({
  primaryNavigation,
  secondaryNavigation,
  pathname,
  projectSlug,
  isNotificationPanelOpen,
}: {
  primaryNavigation: NavItem[];
  secondaryNavigation: NavItem[];
  pathname: string;
  projectSlug?: string;
  isNotificationPanelOpen: boolean;
}): ActiveNavItems {
  const activePathnames = getActivePathnames(pathname, projectSlug);
  let activeNavItemId: string | null = null;
  let activeGroupNavItemId: string | null = null;
  let notificationItemId: string | null = null;

  const findActiveNavItems = (navItems: NavItem[]) => {
    for (const navItem of navItems) {
      if (navItem.type === 'GROUP' && 'items' in navItem && navItem.items) {
        const activeNavItem = getActiveNavItem({
          navItems: navItem.items as NavItems,
          activePathnames,
        });

        const isGroupActive = getIsNavGroupActive({
          item: navItem as Parameters<typeof getIsNavGroupActive>[0]['item'],
          activeMenuItemId: null,
          activePathnames,
          projectSlug,
        });

        if (isGroupActive || activeNavItem) {
          activeGroupNavItemId = isGroupActive ? navItem.id : null;
          activeNavItemId = activeNavItem?.id ?? null;
        }
      } else if (navItem.type === 'URL' && 'url' in navItem) {
        const isActive = getIsPathActive({
          activePathnames,
          path: navItem.url,
        });
        if (isActive) {
          activeNavItemId = navItem.id;
        }
      } else if (
        navItem.type === 'ACTION' &&
        'action' in navItem &&
        navItem.action === 'showNotifications' &&
        isNotificationPanelOpen
      ) {
        notificationItemId = navItem.id;
      }
    }
  };

  findActiveNavItems(primaryNavigation);
  findActiveNavItems(secondaryNavigation ?? []);

  return {
    activeGroupId: isNotificationPanelOpen ? null : activeGroupNavItemId,
    activeItemId: isNotificationPanelOpen ? notificationItemId : activeNavItemId,
  };
}
